import React, { Component } from 'react';
import DropdownTreeSelect from "react-dropdown-tree-select";
import data from "../../../content/data/countries.json";
import '../../../content/css/RedflagComponent.css';
import 'react-dropdown-tree-select/dist/styles.css'

export default class CountryDropdownTreeSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data
        };
    }

    componentDidMount() {
        this.setState({ data: this.toggleSelected(this.state.data, this.props.initialSelection) });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.initialSelection !== this.props.initialSelection) {
            this.setState({ data: this.toggleSelected(this.state.data, this.props.initialSelection) });
        }
    }

    flattenSelected = (data) => {
        let selected = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].checked) selected.push(data[i].value);
            if (data[i].children && data[i].children.length > 0) selected = selected.concat(this.flattenSelected(data[i].children));
        }

        return selected;
    };

    toggleSelected = (data, selected) => {
        let toggledData = this.resetAll(Object.assign([], data));
        for (var i = 0; i < selected.length; i++) {
            this.toggleAll(toggledData, selected[i], true);
        }

        return toggledData;
    };

    toggleAll = (data, value, checked) => {
        for (var i = 0; i < data.length; i++) {
            if (data[i].value === value) {
                data[i].checked = checked;
            }
            if (data[i].children && data[i].children.length > 0) this.toggleAll(data[i].children, value, checked);
        }

        return data;
    };

    resetAll = (data) => {
        for (var i = 0; i < data.length; i++) {
            data[i].checked = false;
            if (data[i].children && data[i].children.length > 0) this.resetAll(data[i].children);
        }

        return data;
    };

    handleChange = ({ value, checked }) => {
        const { data } = this.state;
        let toggledData = this.toggleAll(data, value, checked);
        //this.setState({ data: toggledData });

        let selected = this.flattenSelected(toggledData);
        this.props.onChange(selected);
    };

    render() {
        return (
            <DropdownTreeSelect
                data={this.state.data}
                showDropdown="always"
                showPartiallySelected={true}
                className="G1-redflag-select"
                onChange={this.handleChange}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CategoryView/Redflag/CountryDropdownTreeSelect.js